module.exports = __webpack_public_path__ + "img/10.704986e2.webp";